import { Pipe, PipeTransform } from '@angular/core';
import { filter, get } from 'lodash';

@Pipe({ name: 'count' })
export class CountPipe implements PipeTransform {
  transform(data: any[], filterData: any): number {
    return get(filter(data, filterData), 'length', 0);
  }
}
